export const FETCH_SERVICES_REQUEST = 'FETCH_SERVICES_REQUEST';
export const FETCH_SERVICES_SUCCESS = 'FETCH_SERVICES_SUCCESS';
export const FETCH_SERVICES_FAILURE = 'FETCH_SERVICES_FAILURE';

export const CREATE_SERVICE_REQUEST = 'CREATE_SERVICE_REQUEST';
export const CREATE_SERVICE_SUCCESS = 'CREATE_SERVICE_SUCCESS';
export const CREATE_SERVICE_FAILURE = 'CREATE_SERVICE_FAILURE';

export const UPDATE_SERVICE_REQUEST = 'UPDATE_SERVICE_REQUEST';
export const UPDATE_SERVICE_SUCCESS = 'UPDATE_SERVICE_SUCCESS';
export const UPDATE_SERVICE_FAILURE = 'UPDATE_SERVICE_FAILURE';

export const DELETE_SERVICE_REQUEST = 'DELETE_SERVICE_REQUEST';
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS';
export const DELETE_SERVICE_FAILURE = 'DELETE_SERVICE_FAILURE';

export const fetchServicesRequest = (projectId, options = {}) => {
    const { page = 1, limit = 1, search = '' } = options;
    return {
        type: FETCH_SERVICES_REQUEST,
        payload: { projectId,page, limit, search },
        
      }; 
    };
export const fetchServicesSuccess = (services) => ({ type: FETCH_SERVICES_SUCCESS, payload: services });
export const fetchServicesFailure = (error) => ({ type: FETCH_SERVICES_FAILURE, payload: error });

export const createServiceRequest = (data, projectId) => ({ type: CREATE_SERVICE_REQUEST, payload: { data, projectId } });
export const createServiceSuccess = (service) => ({ type: CREATE_SERVICE_SUCCESS, payload: service });
export const createServiceFailure = (error) => ({ type: CREATE_SERVICE_FAILURE, payload: error });

export const updateServiceRequest = (id, data,projectId) => ({ type: UPDATE_SERVICE_REQUEST, payload: { id, data ,projectId} });
export const updateServiceSuccess = (service) => ({ type: UPDATE_SERVICE_SUCCESS, payload: service });
export const updateServiceFailure = (error) => ({ type: UPDATE_SERVICE_FAILURE, payload: error });

export const deleteServiceRequest = (projectId,id) => ({ type: DELETE_SERVICE_REQUEST, payload: {id,projectId} });
export const deleteServiceSuccess = (id) => ({ type: DELETE_SERVICE_SUCCESS, payload: id });
export const deleteServiceFailure = (error) => ({ type: DELETE_SERVICE_FAILURE, payload: error });
